import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.q41_1 = operation;
        this.r41_1 = null;
        this.s41_1 = Companion_getInstance().d42_1;
        this.t41_1 = null;
        this.u41_1 = null;
        this.v41_1 = null;
        this.w41_1 = null;
        this.x41_1 = null;
        this.y41_1 = null;
        this.z41_1 = null;
        this.a42_1 = null;
        this.b42_1 = null;
        this.c42_1 = true;
      }
      e42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.r41_1 = requestUuid;
        return this;
      }
      f42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.s41_1 = executionContext;
        return this;
      }
      g42(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.z41_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      h42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.t41_1 = httpMethod;
        return this;
      }
      i42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.u41_1 = httpHeaders;
        return this;
      }
      j42(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.u41_1;
        tmp.u41_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      k42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.w41_1 = sendApqExtensions;
        return this;
      }
      l42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.x41_1 = sendDocument;
        return this;
      }
      m42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.v41_1 = enableAutoPersistedQueries;
        return this;
      }
      n42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.y41_1 = canBeBatched;
        return this;
      }
      o42(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.a42_1 = retryOnError;
        return this;
      }
      p42(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.b42_1 = failFastIfOffline;
        return this;
      }
      q42(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.c42_1 = sendEnhancedClientAwareness;
        return this;
      }
      y36() {
        var tmp0_elvis_lhs = this.r41_1;
        return new (ApolloRequest())(this.q41_1, tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs, this.s41_1, this.t41_1, this.u41_1, this.w41_1, this.x41_1, this.v41_1, this.y41_1, this.z41_1, this.a42_1, this.b42_1, this.c42_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.r42_1 = operation;
        this.s42_1 = requestUuid;
        this.t42_1 = executionContext;
        this.u42_1 = httpMethod;
        this.v42_1 = httpHeaders;
        this.w42_1 = sendApqExtensions;
        this.x42_1 = sendDocument;
        this.y42_1 = enableAutoPersistedQueries;
        this.z42_1 = canBeBatched;
        this.a43_1 = ignoreApolloClientHttpHeaders;
        this.b43_1 = retryOnError;
        this.c43_1 = failFastIfOffline;
        this.d43_1 = sendEnhancedClientAwareness;
      }
      e43() {
        return this.f43(this.r42_1);
      }
      f43(operation) {
        return (new (Builder())(operation)).e42(this.s42_1).f42(this.t42_1).h42(this.u42_1).i42(this.v42_1).k42(this.w42_1).l42(this.x42_1).m42(this.y42_1).n42(this.z42_1).o42(this.b43_1).p42(this.c43_1).g42(this.a43_1).q42(this.d43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
